import { defineComponent as _defineComponent } from 'vue'
import ListLayout from "@/components_v3/layout/ListLayout.vue";
import { computed, nextTick, onBeforeMount, onMounted, ref, shallowRef, watch } from "vue";
import HoldTable from "@/components_v3/affiliate-balance/hold/ui/HoldTable.vue";
import HoldConstructor from "@/components_v3/affiliate-balance/hold/ui/HoldConstructor.vue";
import ReloadButton from "@/components-UI/buttons/ReloadButton.vue";
// import DownloadButton from "@/components-UI/buttons/DownloadButton.vue";
// import { downloadExcelFile, showServerError } from "@/utils";
// import { getHoldHistoryBff } from "@/api/affiliate-balance";
import store from "@/store";
import { useRoute, useRouter } from "vue-router/composables";
import { HoldFilters } from "@/services/TablePage/hold";
import ReportFilterByDate from "@/components/statistics/extended-report/ReportFilterByDate.vue";
import type { IFilter } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'HoldList',
  setup(__props) {

const constructor = ref(null);
const tableComp = ref(null);
// const isExportLoading = ref(false);
const route = useRoute();
const router = useRouter();
const filtersClass = ref<HoldFilters>({});

const titleDateFilter = shallowRef<IFilter | null>(null);

onBeforeMount(() => {
    filtersClass.value = new HoldFilters();
    titleDateFilter.value = filtersClass.value.filters?.find((f) => f.id === 'date') ?? null;
});

const isDisableGetReport = computed(() => {
    const p = store.getters['GET_FILTERS_PARAMS_OBJECT'] as Record<string, unknown>;
    if (p?.date_from && p?.date_to) return false;
    const dateFrom = route.query.date_from;
    const dateTo = route.query.date_to;
    return !dateFrom || !dateTo;
});

const readDateFromRouteOrStore = (): [string, string] | null => {
    const q = route.query;
    const qFrom = Array.isArray(q.date_from) ? q.date_from[0] : q.date_from;
    const qTo = Array.isArray(q.date_to) ? q.date_to[0] : q.date_to;
    if (typeof qFrom === 'string' && qFrom && typeof qTo === 'string' && qTo) {
        return [qFrom, qTo];
    }
    const p = store.getters['GET_FILTERS_PARAMS_OBJECT'] as Record<string, unknown>;
    const from = p?.date_from;
    const to = p?.date_to;
    if (typeof from === 'string' && from && typeof to === 'string' && to) {
        return [from, to];
    }
    return null;
};

const syncTitleDateFilterFromRouteOrStore = (): void => {
    const f = titleDateFilter.value;
    if (!f) return;
    const range = readDateFromRouteOrStore();
    if (!range) return;
    const [from, to] = range;
    if (f.select?.length === 2 && f.select[0] === from && f.select[1] === to) return;
    f.select = [from, to];
};

onMounted(() => {
    nextTick(() => {
        syncTitleDateFilterFromRouteOrStore();
    });
});

watch(
    () => {
        const p = store.getters['GET_FILTERS_PARAMS_OBJECT'] as Record<string, unknown>;
        return [p?.date_from, p?.date_to] as const;
    },
    () => {
        syncTitleDateFilterFromRouteOrStore();
    },
);

watch(
    () => [route.query.date_from, route.query.date_to] as const,
    () => {
        syncTitleDateFilterFromRouteOrStore();
    },
);

const pushTitleDatesToStoreAndRoute = (): void => {
    const f = titleDateFilter.value;
    const select = f?.select;
    if (!select || select.length < 2) return;
    const date_from = select[0];
    const date_to = select[1];
    store.commit('SET_FILTERS_PARAMS_OBJECT', {
        ...store.getters['GET_FILTERS_PARAMS_OBJECT'],
        date_from,
        date_to,
    });
    router.replace({
        query: {
            ...route.query,
            date_from,
            date_to,
        },
    }).catch((err) => {
        if (err.name !== 'NavigationDuplicated') {
            throw err;
        }
    });
};

const onTitleDateChange = (): void => {
    pushTitleDatesToStoreAndRoute();
    resetPage();
};

const resetPage = (): void => {
    if (tableComp.value) {
        tableComp.value.resetPage();
    }
};

const getReport = () => {
    if (tableComp.value) {
        // кнопка «Обновить» — принудительный перезапрос мимо дедупликации
        tableComp.value.getHoldList(true);
    }
};

// const exportHold = async () => {
//     try {
//         isExportLoading.value = true;
//         const params = getParams(true);
//         const file = await getHoldHistoryBff(params, true);
//         const dateFrom = route.query.date_from ?? '';
//         const dateTo = route.query.date_to ?? '';
//         const name = `Hold_отчет_${dateFrom}_${dateTo}`;
//         downloadExcelFile(file, name, 'csv', true);
//     } catch (err) {
//         showServerError(err, 'Не удалось скачать выгрузку');
//     } finally {
//         isExportLoading.value = false;
//     }
// };

// const resolveColumns = (): string[] => {
//     const fromConstructor = constructor?.value?.selected as string[] | undefined;
//     if (fromConstructor?.length) {
//         return fromConstructor;
//     }
//     const q = route.query.columns;
//     if (Array.isArray(q)) {
//         const list = q.filter(Boolean) as string[];
//         if (list.length) return list;
//     } else if (typeof q === 'string' && q.length) {
//         return q.split(',').map((s) => s.trim()).filter(Boolean);
//     }
//     return holdDefaultColumns;
// };

// const getParams = (isExport = false) => {
//     const rawFilters = { ...store.getters['GET_FILTERS_PARAMS_OBJECT'] };
//     const columns = resolveColumns();
//     const filters = filtersClass.value.prepareFiltersForSend(rawFilters);
//     if (isExport) return { filters, columns };
//     const paging = { limit: 100, offset: 0 };
//     return { filters, columns, paging };
// };

return { __sfc: true,constructor, tableComp, route, router, filtersClass, titleDateFilter, isDisableGetReport, readDateFromRouteOrStore, syncTitleDateFilterFromRouteOrStore, pushTitleDatesToStoreAndRoute, onTitleDateChange, resetPage, getReport, ListLayout, HoldTable, HoldConstructor, ReloadButton, ReportFilterByDate }
}

})